"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.StyledButtonPrimitiveIconContainer = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var React = _interopRequireWildcard(require("react"));

var _defaultTheme = _interopRequireDefault(require("../../../defaultTheme"));

var _transition = _interopRequireDefault(require("../../../utils/transition"));

var StyledButtonPrimitiveIconContainer = (0, _styledComponents.default)(function (_ref) {
  var className = _ref.className,
      children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, children);
}).withConfig({
  displayName: "ButtonPrimitiveIconContainer__StyledButtonPrimitiveIconContainer",
  componentId: "sc-8i4s5r-0"
})(["", ""], function (_ref2) {
  var margin = _ref2.margin,
      width = _ref2.width,
      height = _ref2.height;
  return (0, _styledComponents.css)(["display:flex;flex-direction:row;align-items:center;justify-content:center;margin:", ";color:currentColor;transition:", ";> svg{width:", ";height:", ";}"], margin, (0, _transition.default)(["background", "box-shadow", "color"], "fast", "ease-in-out"), width, height);
}); // $FlowFixMe: https://github.com/flow-typed/flow-typed/issues/3653#issuecomment-568539198

exports.StyledButtonPrimitiveIconContainer = StyledButtonPrimitiveIconContainer;
StyledButtonPrimitiveIconContainer.defaultProps = {
  theme: _defaultTheme.default
};

var ButtonPrimitiveIconContainer = function ButtonPrimitiveIconContainer(_ref3) {
  var margin = _ref3.margin,
      width = _ref3.width,
      height = _ref3.height,
      children = _ref3.children;
  return /*#__PURE__*/React.createElement(StyledButtonPrimitiveIconContainer, {
    margin: margin,
    width: width,
    height: height
  }, children);
};

var _default = ButtonPrimitiveIconContainer;
exports.default = _default;